import { ChevronsUpDownIcon } from "lucide-react"
import { useMemo } from "react"
import { fieldWidthOf, Picker, type FieldWidth } from "@/design-system/index.ts"
import { Button } from "@/primitives/button.tsx"
import { cn } from "@/primitives/utils"
import { browserTimeZone, timeZoneOptions, timeZoneShown } from "./describe.ts"

/**
 * A time zone, chosen from every zone IANA names by searching for its city, its region or its
 * offset, with the browser's own zone first. In a settings row the row sizes its trigger; anywhere
 * else `fieldWidth` does.
 */
export function TimeZoneField({
  value,
  onChange,
  fieldWidth,
}: {
  value: string | null
  onChange: (zone: string) => void
  fieldWidth?: FieldWidth
}) {
  const now = useMemo(() => new Date(), [])
  const options = useMemo(() => timeZoneOptions(now, browserTimeZone()), [now])
  return (
    <Picker
      title="Time zone"
      mode="single"
      value={value}
      onChange={onChange}
      options={options}
      searchPlaceholder="Search time zones"
      width="md"
      trigger={
        <Button
          variant="outline"
          size="sm"
          className={cn("justify-between font-normal", fieldWidth && fieldWidthOf(fieldWidth))}
        >
          <span className="truncate">{timeZoneShown(value, now)}</span>
          <ChevronsUpDownIcon data-icon="inline-end" className="text-subtle-foreground" />
        </Button>
      }
    />
  )
}
